"use client"

import { GetPageQuery } from "apollo"
import {
  BlockRenderer,
  Container,
  ContentText,
  CustomBreadcrumbs,
  ImageTextBlock,
  TopBanner,
} from "ui"
import { NumbersGridBackgroundProps } from "ui/NumbersComponent/NumbersGrid"
import { getBreadCrumbs } from "utils"
import { findProperty } from "utils/findProperty"
import FinancialReportsTab from "../Financial-reports/FinancialReportsTab"
import NewStrategyMain from "./NewStrategyMain"
import Numbers from "./Numbers"
import Reports from "./Reports"
import ReportsBoldContent from "./ReportsBoldContent"

type Props = {
  data: GetPageQuery
  locale: string
  view: string
  lobby?: boolean
  numbersComponentColors?: NumbersGridBackgroundProps
}

function EsgLobby({ data, locale, view, lobby, numbersComponentColors }: Props) {
  const { selfObject, parents } = getBreadCrumbs(data, locale)
  const components = {
    topBanner: TopBanner,
    contentText: ContentText,
    numbersComponent: Numbers,
    esgStrategyMain: NewStrategyMain,
    imageTextBlock: ImageTextBlock,
    eSGReports: Reports,
    eSGReports1: ReportsBoldContent,
    financialReportsMain1: FinancialReportsTab,
    esgReportsMain: FinancialReportsTab,
  }
  const blocks = findProperty(data.page, "blocks")?.blocks || []
  const hasBanner = blocks?.some(
    (block: any) => block.blockType === "topBanner" || block.blockType === "HeaderWithHeroAndText",
  )

  return (
    <>
      <Container>
        <CustomBreadcrumbs current={selfObject} parents={parents} />
      </Container>
      {blocks?.map((block: any, index: number) => {
        let additionalProps = {}
        if (block.blockType === "numbersComponent1") {
          additionalProps = { accentColor: "black" }
        } else if (block.blockType === "numbersComponent") {
          additionalProps = { backgroundColors: numbersComponentColors, showIcons: false }
        } else if (block.blockType === "eSGReports") {
          additionalProps = { borderB: true, view }
        } else if (block.blockType === "eSGReports1") {
          additionalProps = { borderB: true, view }
        } else if (block.blockType === "imageTextBlock") {
          additionalProps = { lobby }
        } else if (block.blockType === "topBanner") {
          additionalProps = { videoHeight: "500px", imageHeight: "500px" }
        } else if (block.blockType === "contentText") {
          additionalProps = {
            hasBanner: hasBanner,
          }
        } else if (block.blockType === "financialReportsMain1") {
          additionalProps = {
            costumPadding: "40px",
          }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            locale={locale}
            components={components}
            props={additionalProps}
          />
        )
      })}
    </>
  )
}

export default EsgLobby
